import {
  useQuery,
  UseQueryOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { GETProgramCatalogCategories } from '../requests'
import { ProgramCategory } from '../schema'

/**
 * Custom hook to fetch program catalog categories with TypeScript support
 * @param programId - The ID of the program
 * @param options - Additional React Query options
 */
export const useGetProgramCatalogCategories = (
  programId: number,
  options?: Omit<
    UseQueryOptions<ProgramCategory[], Error>,
    'queryKey' | 'queryFn'
  >
) => {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['programCatalogCategories', programId],
    queryFn: async () => await GETProgramCatalogCategories({ programId }),
    ...options,
  })

  // Invalidation function included in the hook return value
  const invalidateQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ['programCatalogCategories', programId],
    })
  }

  // Return both the query result and the invalidation function
  return {
    query,
    invalidateQuery,
    refetch: query.refetch,
  }
}
